import React from 'react';
import { Avatar, Popover } from 'antd';
import { connect } from 'react-redux';
import { signOut } from 'ACTIONS/auth.actions';
import PropTypes from 'prop-types';
import UserMenuContent from './UserMenuContent';
import './UserMenu.less';

const UserMenu = ({ currentUser, signOut: signOutAction }) => currentUser && (
  <div className="user-avatar">
    <Popover placement="bottomRight" title={currentUser.name} content={<UserMenuContent signOutAction={signOutAction} />} trigger="click">
      <Avatar src={currentUser.avatar} />
    </Popover>
  </div>
);

UserMenu.defaultProps = {
  currentUser: null,
};

UserMenu.propTypes = {
  currentUser: PropTypes.object,
  signOut: PropTypes.func.isRequired,
};


const mapStateToProps = ({ auth }) => auth;

export default connect(mapStateToProps, { signOut })(UserMenu);



// WEBPACK FOOTER //
// ./src/components/Layout/Main/UserMenu/UserMenu.js